import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import mitt from 'mitt';
import Axios from 'axios';
import { marked } from 'marked';
import markedFootnote from 'marked-footnote';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Link from '@/components/ui/Link.vue';
import Button from '@/components/ui/Button.vue';
import { setupAxiosCache, checkAndClearCacheFromURL } from '@/utils/axiosCache';
const emitter = mitt();

const renderer = (str) => {
  if (typeof str !== 'string') return '';
  marked.use(markedFootnote());
  return marked(str, { breaks: true });
};

//.use(markedFootnote())

const ajax = Axios.create({
  baseURL: window.globals.api_url,
  withCredentials: true,
});

// 设置axios缓存
const cache = setupAxiosCache(ajax, {
  maxAge: 15 * 60 * 1000, // 缓存15分钟
  maxSize: 100, // 最多缓存100个请求
  storage: true, // 使用localStorage持久化
  debug: process.env.NODE_ENV === 'development', // 开发环境显示调试信息
  methods: ['get'], // 只缓存GET请求
  exclude: [
    // 可以添加不需要缓存的URL模式
    // /\/api\/user/, // 例如：用户相关接口不缓存
  ],
});

// 检查URL参数，如果存在clearCache参数则清除所有缓存
checkAndClearCacheFromURL(cache);

const isExternal = (url) => {
  // console.log(new URL(url, location.origin).origin, window.globals.home_url);
  const or = new URL(url, location.origin).origin;
  const ur = new URL(window.globals.home_url, location.origin).origin;

  // console.log(or, ur, or.indexOf(ur) === -1)

  if (process.env.NODE_ENV === 'production') {
    return or.indexOf(ur) === -1;
  } else {
    return or.indexOf('http://127.0.0.1:8080') === -1;
  }
};

const updateDocumentTitle = (title) => {
  document.title = window.globals.name + ' — ' + title;

  setTimeout(() => {
    const uls = document.querySelectorAll('.ui-enter');

    uls.forEach((ul) => {
      const as = ul.querySelectorAll('a');
      as.forEach((a) => {
        a.addEventListener('click', (e) => {
          if (e.target.dataset.footnoteRef === '' || e.target.dataset.footnoteBackref === '') {
            e.preventDefault();

            const el = document.querySelector(e.target.getAttribute('href'));
            if (el !== null) el.scrollIntoView({ behavior: 'smooth' });

            // console.log(el)
          }
        });
      });
    });
  }, 100);
};

const extractText = (text, isEn = false) => {
  if (!text) return '';

  if (isEn) {
    // Remove Chinese characters and related punctuation, keep English and other characters
    return text.replace(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]+/g, '').trim();
  } else {
    // Match Chinese characters and related punctuation
    const chineseMatch = text.match(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]+/g);
    return chineseMatch ? chineseMatch.join('') : '';
  }
};

const app = createApp(App);

// app.directive('observe-visibility', {
//     beforeMount: (el, binding, vnode) => {
//         vnode.context = binding.instance;
//         ObserveVisibility.bind(el, binding, vnode);
//     },

//     update: ObserveVisibility.update,
//     unmounted: ObserveVisibility.unbind,
// });

// app.component('slide-up-down', SlideUpDown);
app.component('ui-link', Link);
app.component('ui-button', Button);
app.component('svg-icon', SvgIcon);

app.use(store);
app.use(router);
// app.use(VueMasonryPlugin)

// app.provide('$ajax', ajax);
app.config.globalProperties.$ajax = ajax;
app.config.globalProperties.$cache = cache; // 暴露缓存实例，可手动控制
app.config.globalProperties.isExternal = isExternal;
app.config.globalProperties.updateDocumentTitle = updateDocumentTitle;
app.config.globalProperties.marked = renderer;
app.config.globalProperties.extractText = extractText;
app.config.globalProperties.EventBus = emitter;
app.mount('#app');
